export default "__VITE_ASSET__DBGl9wfM__"